import { Component, DestroyRef, inject, Input, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SharedModule } from 'src/app/core/shared/shared.module';
import {
  CommonTableComponent,
  QueryParamsModel,
  QueryResultsModel,
  TableColumn
} from 'src/app/layouts/components/common-table/common-table.component';
import { ProgramBrandingService } from '../../program-branding.service';
import { AppSettingsService } from 'src/app/core/app-settings.service';
import { ApproveLabelComponent } from './approve-label/approve-label.component';
import { ListRefreshService } from 'src/app/service/list-refresh/list-refresh.service';
import { Subject, Subscription, firstValueFrom, takeUntil } from 'rxjs';
import { environment } from 'src/assets/environments/environment.prod';
import moment from 'moment';
import { PreviewBrandCertificateComponent } from '../preview-brand-certificate/preview-brand-certificate.component';
import { DataService } from 'src/app/pages/home/program-license-agreement-process/data.service';
import { UserAuthenticationService } from 'src/app/core/navigation/user-authentication.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ViewPdfComponent } from 'src/app/pages/master-data/program-config/components/view-pdf/view-pdf.component';
import { ListConfigurationService } from 'src/app/pages/list-configuration/list-configuration.service';

@Component({
  selector: 'vex-product-label-list',
  templateUrl: './product-label-list.component.html',
  styleUrls: ['./product-label-list.component.scss'],
  imports: [CommonTableComponent],
  standalone: true
})
export class ProductLabelListComponent {
  @Input() programConfigId: any;
  @Input() programDetails: any;
  @ViewChild('cnTable', { static: true })
  commonTableRef!: CommonTableComponent;
  public actions: Array<any> = [];
  public burgerActions: Array<any> = [];
  public columns: TableColumn<any>[] = [
    { label: 'ID', property: 'id', type: 'text', visible: false },
    { label: 'Brand Name', property: 'brandName', type: 'text', visible: true },
    {
      label: 'Brand Registration Id',
      property: 'brandNameRegistrationId',
      type: 'text',
      visible: true
    },
    {
      label: 'Brand Registration Expiration Date',
      property: 'Form08ExpDate',
      type: 'text',
      visible: true
    },

    {
      label: 'Label Received Date',
      property: 'dateSubmitted',
      type: 'text',
      visible: true
    },

    {
      label: 'Status',
      property: 'LabelApprove',
      type: 'text',
      visible: true
    },
    {
      label: 'Actions',
      property: 'actions',
      type: 'button',
      visible: true
    }
  ];
  filter: any = {};
  registeredBrandData: any[] = [];
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  userInfo: any;
  labelApproveData: any[] = [];
  userRole: any;
  isCompany: boolean = false;
  isAdmin: boolean = false;
  isLoading = true;
  imageUrl: any;
  private subscription: Subscription;
  private isComponentInitialized: boolean = false;
  companyId: any;
  type: any = null;
  title: string = 'Product Label List';
  private readonly destroyRef: DestroyRef = inject(DestroyRef);
  crumbs: any = '';
  badgeFilterItems = [
    { value: 'all', name: 'All' },
    { value: 'Pending', name: 'Pending' },
    { value: 'Yes', name: 'Completed' },
    { value: 'No', name: 'Rejected' }
  ];
  LabelApproveStatus: string | null = null;
  searchBy: any[] = [];
  constructor(
    private dialog: MatDialog,
    private programBrandingService: ProgramBrandingService,
    public appSettingsService: AppSettingsService,
    private listRefreshService: ListRefreshService,
    private dataService: DataService,
    public userCheck: UserAuthenticationService,
    private route: ActivatedRoute,
    private _router: Router,
    private listConfigurationService: ListConfigurationService
  ) {}
  async ngOnInit() {
    this.companyId = this.route.snapshot.queryParams['companyId'];

    this.isComponentInitialized = true;
    this.userInfo = this.appSettingsService.userData().userDetails;
    this.userRole = this.appSettingsService.getUserRole();
    this.getListViewColumns('productLabels');
    this.burgerActions = [
      {
        key: 'file',
        icon: 'mat:remove_red_eye',
        label: 'Review Submitted Label'
      },
      {
        key: 'brandCertificate',
        icon: 'mat:remove_red_eye',
        label: 'View Certificate of Brand Registration'
      },
      {
        key: 'brandCertificateDownload',
        icon: 'mat:download',
        label: 'Download Certificate of Brand Registration'
      }

      // {
      //   key: 'delete',
      //   icon: 'mat:delete_forever',
      //   label: 'Delete'
      // }
    ];

    this.isComponentInitialized = true;
    this.type = this.route.snapshot.queryParams['type'];
    console.log('type:', this.type);
    if (this.type == 'product-label-list') {
      this.title = 'Product Labeling';
    } else if (this.type == 'BrandRegistrationCertificates') {
      this.title = 'Brand Registration Certificates';
    } else if (this.type == 'review-approved-labels') {
      this.title = 'Review Approved Labels';
    } else {
      // Redirect to the error 404 page if the type is not recognized
      // this._router.navigate(['/program/not-found']);
      // this._router.navigate(['/sample'], {
      //   queryParams: {
      //     type: 'SubmittedFormulations'
      //   }
      // });
    }

    if (this.userRole == 'ROLE_ADMIN') {
      this.filter.where = {
        programConfigId: this.programConfigId
      };

      this.isCompany = true;
      this.isAdmin = true;

      const actionsIndex = this.columns.findIndex(
        (column) => column.property === 'actions'
      );

      const newColumns: TableColumn<any>[] = [
        {
          label: 'Company',
          property: 'CompanyName',
          type: 'text',
          visible: true
        }
      ];

      // Insert new columns before the "Actions" column
      this.columns.splice(actionsIndex, 0, ...newColumns);
    } else {
      this.filter.where = {
        companyId: this.userInfo.company.id,
        programConfigId: this.programConfigId
      };

      this.isAdmin = false;
    }
    this.listRefreshService
      .getListObservable()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((res) => {
        if (res) {
          this.init();
          this.commonTableRef.initLoadItems();
        }
      });

    //subscribe program value selected
    this.subscription = this.dataService.program$.subscribe((res: any) => {
      if (res) {
        this.programConfigId = res?.id;
        this.programDetails = res;
        if (!this.isComponentInitialized) {
          this.commonTableRef.initLoadItems();
        }

        // After initial setup, set the flag to false
        this.isComponentInitialized = false;
      }
    });

    this._router.events
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.type = this.route.snapshot.queryParams['type'];
          this.companyId = this.route.snapshot.queryParams['companyId'];
          if (this.type == 'product-label-list') {
            this.title = 'Product Labeling';
          } else if (this.type == 'BrandRegistrationCertificates') {
            this.title = 'Brand Registration Certificates';
          } else {
            // Redirect to the error 404 page if the type is not recognized
            // this._router.navigate(['/program/not-found']);
            // this._router.navigate(['/brand'], {
            //   queryParams: {
            //     type: 'brand'
            //   }
            // });
          }
          this.commonTableRef.initLoadItems();
        }
      });

    if (this.userCheck.checkUser()) {
      this.crumbs = '';
    } else {
      this.crumbs = { label: 'Dashboard', path: '/program/dashboard' };
    }
  }
  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  currentProgram: any;
  async init() {
    try {
      this.currentProgram = await firstValueFrom(
        this.dataService.getUserData()
      );
      if (this.currentProgram) {
        this.programDetails = this.currentProgram;
        this.programConfigId = this.currentProgram?.id;
      }
      this.inItFilterOptions();
    } catch {}
  }

  inItFilterOptions() {
    this.filter.where = {
      companyId: !this.userCheck.checkUser()
        ? this.userInfo.company.id
        : this.companyId
        ? this.companyId
        : null,
      programConfigId: this.programConfigId,
      LabelApprove:
        this.type == 'BrandRegistrationCertificates'
          ? 'Yes'
          : this.LabelApproveStatus == 'all'
          ? null
          : this.LabelApproveStatus
    };
  }
  public async onLoadItemsEvent(queryParams: QueryParamsModel) {
    this.isLoading = true;
    await this.init();
    if (Object.keys(this.filter).length) {
      queryParams.filter = JSON.stringify(this.filter);
    }
    this.programBrandingService.getproductLabelList(queryParams).subscribe(
      (resp) => {
        this.isLoading = false;
        this.commonTableRef.loadItems(resp);
      },
      (error) => {
        console.error('Error loading product label list:', error);
      }
    );
  }

  onActionClickEmit(ev: any) {
    let key = ev.action.key;
    console.log(' ev.data :>> ', ev.data);
    switch (key) {
      case 'file':
        if (this.userCheck.checkUser()) {
          this._router.navigate([
            `product-label-list/product-label-approve/${ev.data.id}`
          ]);
        } else {
          this.onApproveClick(ev.data);
        }
        break;
      case 'delete':
        this.onDeleteClick(ev.data.id);
        break;
      case 'brandCertificate':
        this.viewCertificate(ev.data?.certificateAttachment?.file);
        break;
      case 'brandCertificateDownload':
        this.onDownload(
          ev.data?.certificateAttachment?.file,
          ev.data?.certificateAttachment?.originalFileName
        );
        break;
      default:
        break;
    }
  }
  onApproveClick(data: any) {
    let dialogRef: MatDialogRef<ApproveLabelComponent>;
    dialogRef = this.dialog.open(ApproveLabelComponent, {
      width: '60%', // Default width for larger screens
      maxWidth: '100%', // Ensure it doesn't go beyond the screen width
      height: 'auto', // Allow dynamic height
      data: {
        id: data.labelId,
        isCompany: this.isCompany,
        isAdmin: this.isAdmin,
        sampleDetails: data.sampleDetails
      },
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe((resp) => {
      if (resp) {
        this.commonTableRef.initLoadItems();
      }
    });
  }
  onAddClick() {
    // let dialogRef: MatDialogRef<ProductLabelEditComponent>;
    // dialogRef = this.dialog.open(ProductLabelEditComponent, {
    //   width: '60%',
    //   data: this.registeredBrandData
    // });
    // dialogRef.afterClosed().subscribe((resp) => {
    //   if (resp) {
    //     this.commonTableRef.initLoadItems();
    //   }
    // });
  }
  // onEditClick(ev: any) {
  //   let dialogRef: MatDialogRef<ProductLabelEditComponent>;
  //   dialogRef = this.dialog.open(ProductLabelEditComponent, {
  //     data: this.registeredBrandData,
  //     width: '60%'
  //   });

  //   dialogRef.afterClosed().subscribe((resp) => {
  //     if (resp) {
  //       this.commonTableRef.initLoadItems();
  //     }
  //   });
  // }
  onDeleteClick(id: any) {
    if (!id) return false;

    // this.appSettingsService
    //   .confirm('Delete', 'Are you sure you want to delete?')
    //   .then((res) => {
    //     if (res) {
    //       this.contactInfoService
    //         .deletecontactInformation(id)
    //         .subscribe((resp: any) => {
    //           if (resp && resp.status) {
    //             this.toastr.success(`${resp.data}`);
    //             this.commonTableRef.initLoadItems();
    //           }
    //         });
    //     }
    //   });
  }

  viewFileData(ev: any) {
    const programImg = this.programDetails.imageUrl;
    const programEmail = this.programDetails.email;
    const programContentURL = this.programDetails.programContentURL;
    const data = {
      programImg: programImg,
      programEmail: programEmail,
      programContentURL: programContentURL,
      companyName: ev?.CompanyName || '-',
      brandName: ev?.brandName || 'brand',
      grade: ev?.VisGrade || '-',
      specification: ev?.SpecName || '-',
      registrationId: ev?.brandNameRegistrationId || '-',
      expiryDate: moment(ev?.Form08ExpDate).format('YYYY MMMM DD') || '-',
      createdDate: moment(ev?.createdAt).format('YYYY MMMM DD') || '-'
    };

    let dialogRef = this.dialog.open(PreviewBrandCertificateComponent, {
      data: {
        data: data,
        isLoading: false
      },
      autoFocus: false,
      width: '100%',
      height: '80vh'
    });
  }
  viewCertificate(ev?: any) {
    this.dialog.open(ViewPdfComponent, {
      width: '80%',
      data: {
        title: 'Certificate of brand registration',
        src: ev
      }
    });
  }
  onDownload(ev: any, filename: string) {
    const fileUrl = ev;

    // Create a temporary link element
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = filename; // You can set the desired filename here
    document.body.appendChild(link);

    // Trigger a click on the link to start the download
    link.click();

    // Remove the link from the DOM
    document.body.removeChild(link);
  }

  //brand bobble status filter
  onBadgeFilterEmit(ev: any) {
    this.LabelApproveStatus = ev.dates?.value;
    this.commonTableRef.initLoadItems(true);
  }

  async getListViewColumns(page: string) {
    try {
      const resp = await firstValueFrom(
        this.listConfigurationService.getlistViewColumns(page)
      );
      let respItems: any = resp.items[0].columns;
      let string = this.userCheck.checkUser() ? 'isCQA' : 'isCompany';
      const filteredColumn = respItems.tableColumn.filter(
        (i: any) => i[string]
      );

      const newColumn = this.userCheck.checkUser()
        ? respItems.tableColumn.map((item: any) => ({
            label: item.label,
            property: item.property,
            type: 'text',
            visible: item.isCQA ? true : false,
            tableName: item.tableName
          }))
        : filteredColumn.map((item: any) => ({
            label: item.label,
            property: item.property,
            type: 'text',
            visible: item.isCompany,
            tableName: item.tableName
          }));

      this.columns = newColumn.length > 0 ? newColumn : this.columns;
      this.columns.push({
        label: 'Actions',
        property: 'actions',
        type: 'button',
        visible: true
      });

      this.searchBy = respItems.searchBy.map((item: any) => item.isActive);
    } catch (err) {
      this.appSettingsService.handleError(err);
    }
  }
}
